export function getInitials(names: string[]): string {
  return names
    .map((item) => {
      return item ? item[0] : "";
    })
    .join("");
}
